import axios from "axios";

export const syncWallet = async (walletId: string, fromDate?: Date) => {
  const { data } = await axios.post(`/wallets/sync/${walletId}`, { fromDate });
  return data;
};
